import { Component } from '@angular/core';

@Component({
  selector: 'app-predictive-page',
  templateUrl: './forecast-page.component.html',
  styleUrls: ['./forecast-page.component.scss'],
})
export class ForecastPageComponent {}
